import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Heading1, Text1 } from "../styled";

const AdditionalInfo = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ padding: "0px 0px 16px 16px" }}>
      <Heading1>{t("order:additionalInfoAndQuestions")}</Heading1>
      <Text1 sx={{ fontStyle: "italic" }}>
        {t("order:contactInformationWillBeAddedHere")}
      </Text1>
    </Box>
  );
};

export default AdditionalInfo;
